import { Link, useLocation } from "react-router-dom";
import { FileText, File, MessageSquare, Bot, FileEdit, Scale } from "lucide-react";

interface LicitacionTabBarProps {
  licitacionId: string;
  documentCount?: number;
  proposalCount?: number;
}

interface Tab {
  label: string;
  href: string;
  icon: React.ReactNode;
  badge?: number;
}

export function LicitacionTabBar({ licitacionId, documentCount, proposalCount }: LicitacionTabBarProps) {
  const { pathname } = useLocation();
  const basePath = `/licitaciones/${licitacionId}`;

  const tabs: Tab[] = [
    { label: "Resumen", href: basePath, icon: <FileText className="h-4 w-4" /> },
    { label: "Documentos", href: `${basePath}/documentos`, icon: <File className="h-4 w-4" />, badge: documentCount },
    { label: "Chat IA", href: `${basePath}/chat`, icon: <MessageSquare className="h-4 w-4" /> },
    { label: "Agentes", href: `${basePath}/agentes`, icon: <Bot className="h-4 w-4" /> },
    { label: "Marco legal", href: `${basePath}/marco-legal`, icon: <Scale className="h-4 w-4" /> },
    { label: "Propuestas", href: `${basePath}/propuestas`, icon: <FileEdit className="h-4 w-4" />, badge: proposalCount },
  ];

  function isActive(tabHref: string): boolean {
    if (tabHref === basePath) return pathname === basePath;
    return pathname?.startsWith(tabHref) ?? false;
  }

  return (
    <div className="bg-white border-b border-gray-200 overflow-x-auto">
      <nav className="flex whitespace-nowrap" aria-label="Navegación de licitación">
        {tabs.map((tab) => {
          const active = isActive(tab.href);
          return (
            <Link
              key={tab.href}
              to={tab.href}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                active
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300"
              }`}
              aria-current={active ? "page" : undefined}
            >
              {tab.icon}
              <span>{tab.label}</span>
              {tab.badge !== undefined && tab.badge > 0 && (
                <span className="ml-1 inline-flex items-center justify-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700">
                  {tab.badge}
                </span>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
